/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntryAttributesDTO } from './EntryAttributesDTO';
import {
    EntryAttributesDTOFromJSON,
    EntryAttributesDTOFromJSONTyped,
    EntryAttributesDTOToJSON,
} from './EntryAttributesDTO';

/**
 * 
 * @export
 * @interface RunsAttributesDTO
 */
export interface RunsAttributesDTO {
    /**
     * Map of experiment name to its attributes
     * @type {{ [key: string]: EntryAttributesDTO; }}
     * @memberof RunsAttributesDTO
     */
    experimentsAttributes?: { [key: string]: EntryAttributesDTO; };
    /**
     * 
     * @type {string}
     * @memberof RunsAttributesDTO
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof RunsAttributesDTO
     */
    organizationName: string;
    /**
     * 
     * @type {string}
     * @memberof RunsAttributesDTO
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof RunsAttributesDTO
     */
    projectName: string;
    /**
     * Map of requested run identifier to its attributes
     * @type {{ [key: string]: EntryAttributesDTO; }}
     * @memberof RunsAttributesDTO
     */
    runsAttributes?: { [key: string]: EntryAttributesDTO; };
}

/**
 * Check if a given object implements the RunsAttributesDTO interface.
 */
export function instanceOfRunsAttributesDTO(value: object): value is RunsAttributesDTO {
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('projectName' in value) || value['projectName'] === undefined) return false;
    return true;
}

export function RunsAttributesDTOFromJSON(json: any): RunsAttributesDTO {
    return RunsAttributesDTOFromJSONTyped(json, false);
}

export function RunsAttributesDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunsAttributesDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'experimentsAttributes': json['experimentsAttributes'] == null ? undefined : (mapValues(json['experimentsAttributes'], EntryAttributesDTOFromJSON)),
        'organizationId': json['organizationId'],
        'organizationName': json['organizationName'],
        'projectId': json['projectId'],
        'projectName': json['projectName'],
        'runsAttributes': json['runsAttributes'] == null ? undefined : (mapValues(json['runsAttributes'], EntryAttributesDTOFromJSON)),
    };
}

export function RunsAttributesDTOToJSON(value?: RunsAttributesDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'experimentsAttributes': value['experimentsAttributes'] == null ? undefined : (mapValues(value['experimentsAttributes'], EntryAttributesDTOToJSON)),
        'organizationId': value['organizationId'],
        'organizationName': value['organizationName'],
        'projectId': value['projectId'],
        'projectName': value['projectName'],
        'runsAttributes': value['runsAttributes'] == null ? undefined : (mapValues(value['runsAttributes'], EntryAttributesDTOToJSON)),
    };
}

